import { ReactNode } from "react";
import { ViewItem } from "../../Components/Views/ViewItem";
import { LeftSideDrawer } from "../Components/LeftSideDrawer";


class WithLeftSide extends ViewItem {

    render() {
        const { children } = this.props
        return <div className="with-left-side">
            <LeftSideDrawer/>
            {children}
        </div>
    }
}

export { WithLeftSide }